import heroImg from '@/assets/cityhero.jpg';
import { useNavigate } from 'react-router-dom';
export const HomeHero = () => {
  const navigate = useNavigate();
  return (
    <div
      style={{ backgroundImage: `url(${heroImg})` }}
      className="relative flex h-[calc(70vh-9rem)] w-full flex-col justify-center bg-cover bg-center bg-no-repeat font-inter md:h-[calc(100vh-11rem)]"
    >
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent"></div>
      <div className="z-[2] flex w-full justify-center">
        <div className="flex w-full max-w-[144rem] flex-wrap rounded-md px-[2rem] pb-[2rem]">
          <div className="w-full rounded-md px-[1.5rem] py-[1.5rem] md:px-[4rem] md:py-[4rem]">
            <h1 className="hidden text-5xl font-bold text-white md:block md:text-6xl">
              Your Property.
              <br /> <p className="pt-[0.5rem]">Perfected by Professionals.</p>
            </h1>
            <h1 className="block text-5xl font-bold leading-[140%] text-white md:hidden md:text-6xl">
              Your Property. Perfected by Professionals.
            </h1>
            <div className="w-full">
              <h2 className="mt-[2rem] max-w-[60rem] text-[1.6rem] font-medium leading-[160%] text-white md:text-[1.6rem]">
                KU Contractors Limited provides expert maintenance, refurbishment, and construction
                solutions — covering everything from plumbing and electrical works to roofing,
                flooring, and landscaping.
              </h2>
            </div>
            <div className="mt-[3rem] flex gap-[2rem] md:mt-8">
              <div
                onClick={() => {
                  navigate('/contact-us');
                }}
                className="flex h-[4.3rem] cursor-pointer flex-row flex-wrap items-center justify-center gap-[1rem] text-[1.8rem] font-[700] text-white hover:text-[#e24e1f]"
              >
                <p>Get A Quote</p>
              </div>
              <div
                onClick={() => {
                  navigate('/services');
                }}
                className="flex h-[4.3rem] cursor-pointer flex-row flex-wrap items-center justify-center gap-[1rem] text-[1.8rem] font-[700] text-white hover:text-[#e24e1f]"
              >
                <p>Services</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
